import { Add } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { editProduct } from '../../../api/products';
import Modal from '../../elements/Modal';
import VideoLinksForm from './VideoLinksForm';

export default function AddVideoLinks({
  fetchData,
  product,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const payload = {
        youtubeLinks: values.link,
      };
      const response = await editProduct(payload, product.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Video links updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message || 'Failed to add a video');
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton variant="text" onClick={handleClickOpen}>
        <Add />
      </IconButton>
      <Modal
        open={open}
        modalTitle="Video links"
        handleClose={handleClose}
        width={'sm'}>
        {error && <Alert severity="error">{error}</Alert>}
        <VideoLinksForm onSubmit={handleSubmit} product={product} />
      </Modal>
    </>
  );
}
